import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { OnboardingPages } from '../../../../common/src/pages.ts';
import { useEffectOnce } from '../../util/use_effect_once.ts';
import { Button } from './button.tsx';
import { goToNextOnboardingStep, Message, recordSurveyResponses } from './common.tsx';
import { Frame } from './frame.tsx';

export const HouseholdWelcome = () => {
  const navigate = useNavigate();

  useEffectOnce(() => {
    void recordSurveyResponses();
  });

  const onContinue = useCallback(async () => {
    await goToNextOnboardingStep(navigate, { from: OnboardingPages.HouseholdWelcome, action: 'continue' });
  }, [navigate]);

  return (
    <Frame
      onboardingPage={OnboardingPages.HouseholdWelcome}
      mainContent={<Message $widthInChars={20}>Welcome, your household is ready to sing!</Message>}
      footerContent={<Button onClick={onContinue}>CONTINUE</Button>}
      onEnterKeypress={onContinue}
      suppressBackButton={true}
    />
  );
};
